module.exports = __webpack_public_path__ + "img/shake.3e99837b.jpeg";